export const GOOGLE_ADS_ACTION_OPEN_PTO_POPUP = 'open-pto-popup';
